import { formatNumber } from "@/lib/format";

/**
 * Cuántas obras sobreviven a cada filtro. Cada barra se mide contra el primer
 * escalón, así se ve de un vistazo qué filtro es el que descarta de verdad.
 */
export function WorkAdvisoryFunnel({
  steps,
}: {
  steps: Array<{ label: string; value: number }>;
}) {
  const top = steps[0]?.value ?? 0;

  return (
    <ol className="space-y-4">
      {steps.map((step, index) => {
        const width = top > 0 ? (step.value / top) * 100 : 0;
        const isLast = index === steps.length - 1;
        return (
          <li key={step.label}>
            <div className="flex items-baseline justify-between gap-3 text-sm">
              <span className="text-muted-foreground">{step.label}</span>
              <span className="shrink-0 font-bold tabular-nums">
                {formatNumber(step.value)}
              </span>
            </div>
            <div className="mt-1.5 h-3 rounded-full bg-muted">
              <div
                className={
                  isLast
                    ? "h-full rounded-full bg-amber-400"
                    : "h-full rounded-full bg-[var(--chart-1)]"
                }
                // Un mínimo visible: un escalón de 23 sobre 4,432 es una barra de
                // medio píxel y parece un cero.
                style={{ width: `${step.value > 0 ? Math.max(width, 2) : 0}%` }}
              />
            </div>
          </li>
        );
      })}
    </ol>
  );
}
